<template>
  <div>
    <!-- 🔶 Barra naranja fija arriba -->
    <div class="top-bar-naranja">
      <div class="info-contacto">
        <v-icon left small>mdi-phone</v-icon>
        +51917915824

        <v-icon left small class="ml-4">mdi-email</v-icon>
        informes@consultora-innova.com

        <v-icon left small class="ml-4">mdi-clock-outline</v-icon>
        Lun- Sáb: 8:00 - 8:00pm
      </div>

      <div class="redes">
        <v-btn icon class="white--text"><v-icon small>mdi-facebook</v-icon></v-btn>
        <v-btn icon class="white--text"><v-icon small>mdi-linkedin</v-icon></v-btn>
        <v-btn icon class="white--text"><v-icon small>mdi-youtube</v-icon></v-btn>
        <v-btn icon class="white--text"><v-icon small>mdi-skype</v-icon></v-btn>

        <v-btn text class="white--text text-caption font-weight-bold ml-2">
          <v-icon left small>mdi-account</v-icon>
          INGRESAR
        </v-btn>
      </div>
    </div>

    <!-- 🔳 Menú principal blanco -->
    <v-app-bar color="white" dense elevate-on-scroll class="main-bar" app>
      <v-toolbar-title>
        <router-link to="/">
          <v-img
            :src="require('@/assets/consultora_innova_ag_logo_horizontal_v2.svg')"
            alt="Logo"
            contain
            height="50"
            max-width="250"
          />
        </router-link>
      </v-toolbar-title>

      <v-spacer />

      <!-- Menú de escritorio -->
      <v-row class="d-none d-md-flex" align="center">
        <v-btn
          v-for="(item, idx) in menuItems"
          :key="idx"
          text
          :to="item.link"
          exact
          :class="{ 'active-item': isActive(item.link) }"
        >
          {{ item.title }}
        </v-btn>

        <v-btn
          v-if="false"
          color="#d7641a"
          class="ml-4 white--text font-weight-bold px-6 py-2"
          rounded
          elevation="3"
          :to="'/contacto'"
        >
          CONTACTO
        </v-btn>
      </v-row>

      <!-- Botón menú hamburguesa para móvil -->
      <div class="d-flex d-md-none">
        <v-app-bar-nav-icon @click="drawer = true" />
      </div>
    </v-app-bar>

    <!-- Drawer lateral móvil -->
    <v-navigation-drawer
      v-model="drawer"
      app
      temporary
      left
      width="260"
      overlay-color="rgba(0,0,0,0.5)"
    >
      <div class="drawer-header">
        <router-link to="/" @click.native="drawer = false">
          <v-img
            :src="require('@/assets/logo-emp.jpg')"
            alt="Logo"
            contain
            height="60"
            max-width="180"
          />
        </router-link>
        <v-btn icon @click="drawer = false" class="close-btn">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </div>

      <v-list dense nav>
        <v-list-item
          v-for="(item, index) in menuItems"
          :key="index"
          :to="item.link"
          router
          @click="drawer = false"
        >
          <v-list-item-icon>
            <v-icon>mdi-chevron-right</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>

<script>
export default {
  data() {
    return {
      drawer: false,
      menuItems: [
        { title: "Inicio", link: "/" },
        { title: "Nosotros", link: "/nosotros" },
        { title: "Servicios", link: "/servicios" },
        { title: "Portafolio", link: "/portafolio" },
        { title: "Blog", link: "/blog" },
        { title: "Contacto", link: "/contacto" },
      ],
    };
  },
  methods: {
    isActive(link) {
      return this.$route.path === link;
    },
  },
};
</script>

<style>
/* Barra superior naranja */
.top-bar-naranja {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 36px;
  background-color: #2191c5;
  color: white;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 24px;
  z-index: 3000;
  font-size: 13px;
}

.info-contacto {
  display: flex;
  align-items: center;
  gap: 12px;
}

.redes {
  display: flex;
  align-items: center;
}

.v-application--wrap {
  padding-top: 0 !important;
}

.main-bar {
  top: 36px !important;
  position: fixed !important;
  z-index: 2000 !important;
  width: 100%;
}

.active-item {
  background-color: #f5c9a0 !important;
  color: #d7641a !important;
  border-radius: 6px;
  font-weight: bold;
  padding: 6px 12px;
}

.mobile-menu-list {
  min-width: 220px;
}

/* Drawer lateral */
.drawer-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  border-bottom: 1px solid #eee;
}

.close-btn {
  color: #d7641a;
}

/* Responsive */
@media (max-width: 600px) {
  .info-contacto {
    display: none !important;
  }
  .top-bar-naranja {
    justify-content: center !important;
  }
}
</style>
